<app-tab-layout [loading]="loading()" [error]="error">
  @if(initialized()){
  <div class="tab-content">
    @if(topFilterEntries().length) {
    <div class="top-filters">
      @for(filterEntry of topFilterEntries(); track filterEntry[0]) {
      <app-select [name]="filterEntry[0]" [options]="filterEntry[1]" type="check" [size]="'sm'"
        (getCheckedItems)="onTopFilterChange(filterEntry[0], $event)">
      </app-select>
      }
    </div>
    }

    <!-- Slide Carousel -->
    <app-carousel #slideCarousel [items]="carouselItems()" [loading]="carouselLoading()"
      emptyMessage="No slides for this section">
    </app-carousel>

    <!-- Section Duration Tab Bars -->
    <div class="section-tabs-container">
      @if(topFiltersLoading()) {
      <div class="section-skeleton" aria-hidden="true">
        <div class="section-skeleton-row">
          @for(_item of [1, 2, 3, 4]; track $index) {
          <div class="section-skeleton-tab">
            <div class="section-skeleton-line title"></div>
            <div class="section-skeleton-line meta"></div>
          </div>
          }
        </div>
      </div>
      } @else {
      <div class="section-tabs">
        @for(section of sectionBars(); track section.Section) {
        <button class="section-tab" [class.selected]="section.isSelected" [style.flex-basis.%]="section.widthPercent"
          (click)="selectSection(section.Section)" [title]="section.Percentage + '%'">
          <div class="section-content">
            <span class="section-name">{{ section.Section }}</span>
            <div class="section-meta">
              <span class="section-percentage">({{ section.Percentage }}%)</span>
              <span class="section-duration">{{ section['Duration(Min)'] }} mins</span>
            </div>
          </div>
        </button>
        }
      </div>
      }
    </div>
  </div>
  }
</app-tab-layout>